import { ButtonBase, CircularProgress } from '@mui/material';
import useAxiosPrivate from 'hooks/useAxiosPrivate';
import { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import Slider from 'react-slick';
import BaseTooltip from './ui/tooltips/BaseTooltip';
import { useSearchParams } from 'react-router-dom';
import CurrencyFormat from './ui/text-formats/CurrencyFormat';
import useAuth from 'hooks/useAuth';

const AccountSlider = ({
  accountId,
  setAccountId,
  setAccountsError,
  emitRefetch,
}) => {
  const [{ user }] = useAuth();
  const settings = (slideCount, slidesToShow) => ({
    dots: false,
    slidesToShow: slidesToShow,
    slidesToScroll: 2,
    swipeToSlide: true,
    arrows: true,
    className: 'slider-wrapper',
    infinite: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: slideCount < 3 ? slideCount : 4,
          slidesToScroll: 2,
          infinite: true,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: slideCount < 3 ? slideCount : 3,
          slidesToScroll: 2,
          infinite: true,
        },
      },
      {
        breakpoint: 987,
        settings: {
          slidesToShow: slideCount < 2 ? slideCount : 2,
          slidesToScroll: 2,
          infinite: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });

  const axiosPrivate = useAxiosPrivate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [hasError, setHasError] = useState(false);

  const accountsUrl =
    user?.user?.role_id == 1
      ? '/admin/accounts/index'
      : '/dictionary/selfaccounts';

  const {
    data: accounts,
    isLoading,
    isFetching,
    refetch,
  } = useQuery({
    queryKey: [accountsUrl],
    queryFn: async function () {
      const response = await axiosPrivate.get(accountsUrl);
      return response.data.data;
    },
    onSuccess: (data) => {
      if (data.length > 0) {
        if (!accountId) setAccountId(data[0]?.id);
      } else {
        setAccountId('');
      }
    },
    onSettled: () => {
      emitRefetch.setRefetch(false);
    },
    enabled: !hasError,
    onError: (error) => {
      setHasError(true);
      setAccountsError(true);
    },
    retry: false,
  });

  useEffect(() => {
    if (emitRefetch && emitRefetch.refetch) {
      refetch();
    }
  }, [emitRefetch.refetch]);

  const handleBlockId = (blockId) => {
    if (searchParams.get('page')) {
      searchParams.set('page', 1);
      setSearchParams(searchParams);
    }
    setAccountId(blockId);
  };

  return (
    <div className='blocks-slider-wrapper'>
      {isLoading || isFetching ? (
        <div className='circular-progress-box h-[100px]'>
          <CircularProgress size={40} />
        </div>
      ) : accounts && accounts?.length > 0 ? (
        <Slider
          {...settings?.(
            accounts?.length,
            accounts?.length < 3 ? accounts?.length : 5
          )}
        >
          {accounts?.map((account) => (
            <ButtonBase
              key={account?.id}
              className={`block-item ${
                account?.id == accountId ? 'item-selected' : ''
              } !base-border !shadow-md !bg-white !py-1 !h-auto`}
              id={`block-${account?.id}`}
              onClick={() => handleBlockId(account?.id)}
            >
              <div className='flex flex-col justify-start items-start py-2 px-4'>
                <div className='block-title'>
                  <BaseTooltip
                    title={account?.name}
                    arrow={true}
                    placement='top'
                    enterDelay={500}
                  >
                    <span>{account?.name}</span>
                  </BaseTooltip>
                </div>
                <div className='text-left text-base'>
                  Obyekt: {account?.object_name}
                </div>
                <div className='text-left text-sm'>
                  Balans:{' '}
                  <CurrencyFormat
                    value={Number(account?.balancesum)}
                    suffix=' UZS'
                    allowNegative
                  />
                </div>
                <div className='text-left text-sm'>
                  Balans:{' '}
                  <CurrencyFormat
                    value={Number(account?.balanceval)}
                    suffix=' $'
                    allowNegative
                  />
                </div>
              </div>
            </ButtonBase>
          ))}
        </Slider>
      ) : (
        <div className='my-6'>
          <span className='no-data-found-wrapper'>
            <i className='bi bi-exclamation-octagon text-xl mr-1 leading-3' />{' '}
            Hisloblar topilmadi!
          </span>
        </div>
      )}
    </div>
  );
};

export default AccountSlider;
